module.exports = __webpack_public_path__ + "img/icon-restore-company.c8a9165d.svg";